import { withHTMLComponent } from '@updater-local/custom-element-v1';
import styles from './index.css';
import html from './index.html';
import { formatNumber } from '../../utils';

export default class CompanyDescription extends withHTMLComponent(
  styles,
  html
)() {
  static props = ['value', 'blankData'];

  constructor() {
    super();

    this._year = this.shadowRoot.querySelector('#year');
    this._moves = this.shadowRoot.querySelector('#moves');
    this._trucks = this.shadowRoot.querySelector('#trucks');
    this._description = this.shadowRoot.querySelector('#description');
  }

  updated({
    value: { yearOfEstablishment, numberOfMoves, numberOfTrucks },
    blankData,
  }) {
    this._year.textContent = yearOfEstablishment;
    this._moves.textContent = formatNumber(numberOfMoves);
    this._trucks.textContent = numberOfTrucks;

    if (blankData) {
      this._description.classList.add('hidden');
    }
  }
}

customElements.define('upd-moveiq-company-description', CompanyDescription);
